
import React, { useState } from "react";
import BusinessSettings from "../../components/settings/websitesettings/BusinessSettings";
import SeoSettings from "../../components/settings/websitesettings/SeoSettings";
import Localization from "../../components/settings/websitesettings/Localization";
import Prefixes from "../../components/settings/websitesettings/Prefixes";
import Preferences from "../../components/settings/websitesettings/Preferences";
import Appearance from "../../components/settings/websitesettings/Appearance";
import Language from "../../components/settings/websitesettings/Language";

import Authentication from "../../components/settings/websitesettings/Authentication";
import AiSettings from "../../components/settings/websitesettings/AiSettings";
import SettingsLayout from "../../components/settings/websitesettings/SettingsLayout";



export default function WebsiteSettingsPage() {
  const [activeTab, setActiveTab] = useState("Business Settings");

  const renderContent = () => {
    switch (activeTab) {
      case "Business Settings":
        return <BusinessSettings />;
      case "SEO Settings":
        return <SeoSettings/>;
      case "Localization":
        return <Localization />;
      case "Prefixes":
        return <Prefixes />;
      case "Preferences":
        return <Preferences />;
      case "Appearance":
        return <Appearance />;
      case "Language":
        return <Language />;
      case "Authentication Settings":
        return <Authentication />;
      case "AI Settings":
        return <AiSettings />;
      default:
        return <BusinessSettings />;
    }
  };

  return (
    <SettingsLayout
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    >
      {renderContent()}
    
    </SettingsLayout>
  );
}